// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
h2[data-v-2d5c8534] {
    margin: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/NotFound.vue"],"names":[],"mappings":";AAsBA;IACA,YAAA;AACA","sourcesContent":["<template>\n    <h2>{{ t('cookbook', 'The page was not found') }}</h2>\n</template>\n\n<script setup>\nimport { onMounted } from 'vue';\nimport { useStore } from '../store';\n\nconst store = useStore();\n\nonMounted(() => {\n    store.dispatch('setPage', { page: 'notfound' });\n});\n</script>\n\n<script>\nexport default {\n    name: 'NotFound',\n};\n</script>\n\n<style scoped>\nh2 {\n    margin: 1rem;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
